// src/components/Layout/Footer.js
import React from 'react';
import styled from 'styled-components';
import { FiHeart } from 'react-icons/fi'; // Using Feather icons for consistency

const FooterWrapper = styled.footer`
  padding: ${({ theme }) => theme.spacing.md} ${({ theme }) => theme.spacing.lg};
  background-color: ${({ theme }) => theme.colors.surface}; /* Or a slightly different shade */
  border-top: 1px solid ${({ theme }) => theme.colors.lightBorder};
  text-align: center;
  font-size: 0.875rem; /* 14px */
  color: ${({ theme }) => theme.colors.textSecondary};
  /* This footer will be inside the main content wrapper that adjusts for the sidebar */
  /* So, it doesn't need its own margin-left adjustments here */
  width: 100%; /* Take full width of its container */
  margin-top: auto; /* Pushes footer to bottom if content is short, within a flex container */
`;

const FooterText = styled.p`
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.xs};
`;

const CreatorLink = styled.a`
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: none;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  
  &:hover {
    text-decoration: underline;
    color: ${({ theme }) => theme.colors.primaryDark}; /* Optional: darker shade on hover */
  }
`;

const HeartIcon = styled(FiHeart)`
  color: ${({ theme }) => theme.colors.danger}; /* Or your primary color */
  margin: 0 0.2em;
  vertical-align: middle;
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterWrapper>
      <FooterText>
        <span>© {currentYear} NowNfc. All rights reserved.</span>
      </FooterText>
      <FooterText>
        <span>Crafted with</span> <HeartIcon size="1.3em" /> <span>by</span>
        <CreatorLink href="https://dheersoftwaresolutions.com/" target="_blank" rel="noopener noreferrer" style={{color:'green' , textDecoration:'none'}}>
          Dheer Software Solutions
        </CreatorLink>
      </FooterText>
    </FooterWrapper>
  );
};

export default Footer;